(function (angular) {
    'use strict';

    angular.module('broadcast')


        .controller('broadcastDetailsViewModal', ["$scope", "$uibModalInstance", "message", "$stateParams", "channel", '$filter', 'audienceName', 'sentBy',
            function ($scope, $uibModalInstance, message, $stateParams, channel, $filter, audienceName, sentBy) {
                $scope.sentBy = sentBy;
                $scope.message = message.content;
                $scope.broadcast = message;
                $scope.pickedApiSpaceId = $stateParams.pickedApiSpaceId;
                $scope.channel = channel;
                $scope.audienceName = audienceName;
                $scope.close = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }])
})(window.angular);